// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::after,
::before {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

a {
    text-decoration: none;
}

li {
    list-style: none;
}

h1 {
    font-weight: 600;
    font-size: 1.5rem;
}

#sidebar {
    width: 70px;
    min-width: 70px;
    z-index: 1000;
    transition: all 0.25s ease-in-out;
    background-color: #0f0f0f;
    display: flex;
    flex-direction: column;
    height: calc(100% - 60px);
    flex-shrink: 0;
    position: fixed;
    top: 60px;
    left: 0;
}
  
#sidebar.expand {
    width: 260px;
    min-width: 260px;
}
  
.navbar {
    position: fixed;
    top: 0;
    height: 60px;
    width: 100%; 
    background-color: #0f0f0f !important;
    z-index: 999; 
    display: flex;
    align-items: center;
    padding: 0 1rem;
    transition: all 0.25s ease-in-out;
}
  
.main-content {
    margin-top: 60px;
    margin-left: 70px;
    transition: all 0.25s ease-in-out;
    /* padding: 1rem; */
    padding: 1%;
}
  
#sidebar.expand ~ .main-content {
    margin-left: 260px;
}
  

.menu {
    background-color: transparent;
    cursor: pointer;
    border: 0;
    /* max-width: 50%; */
}

.toggle-btn i {
    font-size: 1.5rem;
    color: #FFF;
}

.sidebar-logo {
    margin: auto 0;
}

.sidebar-logo {
    color: #FFF;
    font-size: 1.15rem;
    font-weight: 600;
    min-width: 50%;
    margin-left: 20%;
}

#sidebar:not(.expand) .sidebar-logo,
#sidebar:not(.expand) a.sidebar-link span {
    display: none;
}

.sidebar-nav {
    padding: 2rem 0;
    flex: 1 1 auto;
    /* flex-grow: 1; */
    /* flex-shrink: 1; */
    /* flex-basis: auto; */
}

a.sidebar-link {
    padding: .7rem 1.625rem;
    color: #FFF;
    display: block;
    font-size: 1rem;
    white-space: nowrap;
    border-left: 3px solid transparent;
}

.sidebar-link i {
    font-size: 1.1rem;
    margin-right: .75rem;
}

a.sidebar-link:hover {
    background-color: rgba(255, 255, 255, .075);
    border-left: 3px solid #3b7ddd;
}

.sidebar-item {
    position: relative;
}

#sidebar:not(.expand) .sidebar-item .sidebar-dropdown {
    position: absolute;
    top: 0;
    left: 70px;
    background-color: #212529;
    padding: 0;
    min-width: 15rem;
    display: none;
}

#sidebar:not(.expand) .sidebar-item:hover .has-dropdown+.sidebar-dropdown {
    display: block;
    max-height: 15em;
    width: 100%;
    opacity: 1;
}

.sidebar-link {
    position: relative;
}

.sidebar-link[data-tooltip]:hover::after {
    content: attr(data-tooltip);
    position: absolute;
    left: 100%;
    top: 50%;
    transform: translateY(-50%);
    background-color: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 5px 10px;
    font-size: 0.9rem;
    border-radius: 5px;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s ease-in-out;
}

.sidebar-link[data-tooltip]:hover::after {
    opacity: 1;
    visibility: visible;
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/sidebar.css"],"names":[],"mappings":"AAEA;;IAEI,sBAAsB;IACtB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,aAAa;IACb,iCAAiC;IACjC,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,SAAS;IACT,OAAO;AACX;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,YAAY;IACZ,WAAW;IACX,oCAAoC;IACpC,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iCAAiC;IACjC,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI,6BAA6B;IAC7B,eAAe;IACf,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,2CAA2C;IAC3C,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,yBAAyB;IACzB,UAAU;IACV,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,oCAAoC;IACpC,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600&display=swap');\n\n::after,\n::before {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n}\n\na {\n    text-decoration: none;\n}\n\nli {\n    list-style: none;\n}\n\nh1 {\n    font-weight: 600;\n    font-size: 1.5rem;\n}\n\n#sidebar {\n    width: 70px;\n    min-width: 70px;\n    z-index: 1000;\n    transition: all 0.25s ease-in-out;\n    background-color: #0f0f0f;\n    display: flex;\n    flex-direction: column;\n    height: calc(100% - 60px);\n    flex-shrink: 0;\n    position: fixed;\n    top: 60px;\n    left: 0;\n}\n  \n#sidebar.expand {\n    width: 260px;\n    min-width: 260px;\n}\n  \n.navbar {\n    position: fixed;\n    top: 0;\n    height: 60px;\n    width: 100%; \n    background-color: #0f0f0f !important;\n    z-index: 999; \n    display: flex;\n    align-items: center;\n    padding: 0 1rem;\n    transition: all 0.25s ease-in-out;\n}\n  \n.main-content {\n    margin-top: 60px;\n    margin-left: 70px;\n    transition: all 0.25s ease-in-out;\n    /* padding: 1rem; */\n    padding: 1%;\n}\n  \n#sidebar.expand ~ .main-content {\n    margin-left: 260px;\n}\n  \n\n.menu {\n    background-color: transparent;\n    cursor: pointer;\n    border: 0;\n    /* max-width: 50%; */\n}\n\n.toggle-btn i {\n    font-size: 1.5rem;\n    color: #FFF;\n}\n\n.sidebar-logo {\n    margin: auto 0;\n}\n\n.sidebar-logo {\n    color: #FFF;\n    font-size: 1.15rem;\n    font-weight: 600;\n    min-width: 50%;\n    margin-left: 20%;\n}\n\n#sidebar:not(.expand) .sidebar-logo,\n#sidebar:not(.expand) a.sidebar-link span {\n    display: none;\n}\n\n.sidebar-nav {\n    padding: 2rem 0;\n    flex: 1 1 auto;\n    /* flex-grow: 1; */\n    /* flex-shrink: 1; */\n    /* flex-basis: auto; */\n}\n\na.sidebar-link {\n    padding: .7rem 1.625rem;\n    color: #FFF;\n    display: block;\n    font-size: 1rem;\n    white-space: nowrap;\n    border-left: 3px solid transparent;\n}\n\n.sidebar-link i {\n    font-size: 1.1rem;\n    margin-right: .75rem;\n}\n\na.sidebar-link:hover {\n    background-color: rgba(255, 255, 255, .075);\n    border-left: 3px solid #3b7ddd;\n}\n\n.sidebar-item {\n    position: relative;\n}\n\n#sidebar:not(.expand) .sidebar-item .sidebar-dropdown {\n    position: absolute;\n    top: 0;\n    left: 70px;\n    background-color: #212529;\n    padding: 0;\n    min-width: 15rem;\n    display: none;\n}\n\n#sidebar:not(.expand) .sidebar-item:hover .has-dropdown+.sidebar-dropdown {\n    display: block;\n    max-height: 15em;\n    width: 100%;\n    opacity: 1;\n}\n\n.sidebar-link {\n    position: relative;\n}\n\n.sidebar-link[data-tooltip]:hover::after {\n    content: attr(data-tooltip);\n    position: absolute;\n    left: 100%;\n    top: 50%;\n    transform: translateY(-50%);\n    background-color: rgba(0, 0, 0, 0.8);\n    color: white;\n    padding: 5px 10px;\n    font-size: 0.9rem;\n    border-radius: 5px;\n    white-space: nowrap;\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.2s ease-in-out;\n}\n\n.sidebar-link[data-tooltip]:hover::after {\n    opacity: 1;\n    visibility: visible;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
